import { render } from "./InitializeButton.vue?vue&type=template&id=03fd40af"
import script from "./InitializeButton.vue?vue&type=script&lang=js"
export * from "./InitializeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__